import { render, staticRenderFns } from "./SongwriterEditButton.vue?vue&type=template&id=de0ad0c6"
import script from "./SongwriterEditButton.vue?vue&type=script&lang=js"
export * from "./SongwriterEditButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports